// Render-time repair of `proxyIds` that no longer name a visible spouse.
//
// EXTRACTED FROM ChartBox (TGCLOUD-1801), and the extraction is the fix, not
// tidying. In ChartBox this ran as an effect that ALSO set
// `saveStatus.IN_PROGRESS`, which made it the one automatic writer able to fire
// the wholesale member POST with no user gesture at all: IN_PROGRESS is
// forwarded to `onEdit('data')` in PedigreeChart, which is deliberately exempt
// from the has-the-user-interacted gate. So merely OPENING a pedigree whose
// proxyIds did not resolve took the edit lock, pinned the tab, and posted every
// member on screen — and when the member set was wrong, that is what turned a
// bad render into a persisted cross-family write.
//
// A pure function with no access to any setter CANNOT arm a save. That is the
// point of pulling it out here: the property is structural rather than a thing
// the next edit to ChartBox has to remember.
//
// A proxy is the duplicated drawing of a person next to a partner, so a
// proxyId is only meaningful while it names someone who is (a) still in the
// member set and (b) still a spouse of the owner. Anything else is a dangling
// reference that would draw a proxy against nobody.
//
// Returns `null` when there is nothing to repair — callers should skip the
// state update entirely rather than write an equal array, which would re-run
// every effect keyed on memberRecords and, before this change, re-arm the save
// on every pass.
export function pruneUnresolvedProxyIds(records) {
  const rows = records || [];
  const presentPids = new Set(rows.map((m) => m.pid));

  let changed = false;
  const cleaned = rows.map((m) => {
    if (!Array.isArray(m.proxyIds) || m.proxyIds.length === 0) return m;
    const valid = m.proxyIds.filter(
      (pid) => presentPids.has(pid) && (m.spouseIds || []).includes(pid)
    );
    if (valid.length === m.proxyIds.length) return m;
    changed = true;
    return { ...m, proxyIds: valid };
  });

  return changed ? cleaned : null;
}
